import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Artwork from '../FullScreenCarouselItem';

import SelectedPlaylistCarousel from '../SelectedPlaylistCarousel';
import './freemium-full-screen-carousel.scss';
import { setMuteFlag, fireAnalytics } from '../../pages/utils.js';
import { fetchActivePlaylist } from '../../store/actions/playlistActions';
import { FETCH_MOBILE_STATUS_FAILURE } from '../../store/constants/mobileConstants';
import { fetchMobileQueue, fetchMobileStatus } from '../../store/actions/mobileActions';
import { ENTER, BACK, LEFT, UP, RIGHT, DOWN, EXIT } from '../../util/remoteButtons';

export class FreemiumCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: props.selectedArtwork,
      navTimeout: null,
      navigating: false,
      showNav: false,
      nxtLoad: false,
      others: false,
      artworks: props.artworks,
      show: true,
      activeComponent: false,
      currentPlaylist: 0,
      selectedPlaylistId: props.selectedPlaylistId,
      selectedPlaylist: null,
      open: false,
      lastMobileUpdate: null,
      selectedButton: 'view',
      artworkError: false,
    };

    this.fsTimeout = null;
    this.getCurrentArtworkArtistName = this.getCurrentArtworkArtistName.bind(this);
    this.getCurrentArtworkName = this.getCurrentArtworkName.bind(this);
    // this.updateOnlineStatus = this.updateOnlineStatus.bind(this);
    this.setArtworkInterval = this.setArtworkInterval.bind(this);
    this.addOrientationClassToBody = this.addOrientationClassToBody.bind(this);
    this.addOrientationClassToPlaylistCarousel = this.addOrientationClassToPlaylistCarousel.bind(this);
    this.k = 1;
    this.artworkInterval = 300000;
    this.updatePlaylist = true;
    this.mergeMyPlaylist = this.mergeMyPlaylist.bind(this);
    this.hideArtworkNameTimeout = null;
    this.selectedBtn = 'No';
    this.onlineStatusInterval = null;
    this.artworkIntervalTime = null;
    this.artworkErrorMessage = '';
    this.prevPlaylistId = '';
  }

  componentDidMount() {
    fireAnalytics('Page', 'Player Page Loaded');
    window.onkeydown = (e) => {
      if (this.state.navigating) {
        switch (e.keyCode) {
          case ENTER: {
            if (this.state.open) {
              if (this.selectedBtn === 'No') {
                this.setState({ open: false });
                setTimeout(() => {
                  var mainDiv = this.refs.mainDiv;
                  mainDiv.focus();
                }, 700);
              }
              if (this.selectedBtn === 'Yes') {
                tizen.application.getCurrentApplication().exit();
              }
            } else {
              switch (this.state.selectedButton) {
                case 'account': {
                  this.props.history.push('/Account');
                  break;
                }
                case 'upgrade': {
                  this.props.history.push('/Pair');
                  break;
                }
                default:
                  this.setState((prevState) => ({
                    ...prevState,
                    navigating: false,
                    navTimeout: null,
                  }));
                  break;
              }
            }
            break;
          }
          case LEFT: {
            if (this.state.open) {
              document.getElementById('yes').style.background = '';
              document.getElementById('No').style.background = '#910048';
              this.refs.no.focus();
              this.selectedBtn = 'No';
            } else {
              clearTimeout(this.state.navTimeout);
              if (!this.state.activeComponent) {
                this.prevHandle();
                clearInterval(this.artworkIntervalTime);
                this.setArtworkInterval(this.artworkInterval);
              }
            }

            break;
          }
          case RIGHT: {
            if (this.state.open) {
              document.getElementById('No').style.background = '';
              document.getElementById('yes').style.background = '#910048';
              this.refs.yes.focus();
              this.selectedBtn = 'Yes';
            } else {
              clearTimeout(this.state.navTimeout);
              if (!this.state.activeComponent) {
                this.nextHandle();
                clearInterval(this.artworkIntervalTime);
                this.setArtworkInterval(this.artworkInterval);
              }
            }
            break;
          }
          case UP: {
            if (!this.state.open) {
              clearTimeout(this.state.navTimeout);
              const navTimeout = setTimeout(() => {
                this.setState((prevState) => ({
                  ...prevState,
                  navigating: false,
                }));
              }, 4000);

              if (this.props.hasSubscription) {
                this.setState((prevState) => ({
                  ...prevState,
                  selectedButton: 'account',
                  navTimeout,
                }));
                setTimeout(() => {
                  const { accountButton } = this.refs;
                  accountButton.focus();
                }, 300);
              } else {
                this.setState((prevState) => ({
                  ...prevState,
                  selectedButton: 'upgrade',
                  navTimeout,
                }));
                setTimeout(() => {
                  const { upgrade } = this.refs;
                  upgrade.focus();
                }, 300);
              }
              break;
            }
          }
          case 27:
          case BACK: {
            setTimeout(() => {
              var no = this.refs.no;
              no.focus();
            }, 200);
            this.setState({ open: !this.state.open });
            break;
          }
          default:
            break;
        }
      } else if ((e.keyCode === LEFT || e.keyCode === RIGHT || e.keyCode === UP) && !this.state.activeComponent) {
        if (this.state.open && e.keyCode === LEFT) {
          document.getElementById('yes').style.background = '';
          document.getElementById('No').style.background = '#910048';
          this.refs.no.focus();
          this.selectedBtn = 'No';
        } else if (this.state.open && e.keyCode === RIGHT) {
          document.getElementById('No').style.background = '';
          document.getElementById('yes').style.background = '#910048';
          this.refs.yes.focus();
          this.selectedBtn = 'Yes';
        } else {
          clearTimeout(this.state.navTimeout);
          const navTimeout = setTimeout(() => {
            this.setState((prevState) => ({ ...prevState, navigating: false }));
          }, 4000);
          this.setState((prevState) => ({
            ...prevState,
            navigating: true,
            navTimeout,
          }));
        }
      } else if (e.keyCode === DOWN) {
        if (!this.state.open) {
          if (this.state.activeComponent) {
            this.setState(() => ({ activeComponent: false }));
          } else {
            this.addOrientationClassToPlaylistCarousel();
            this.setState(() => ({ activeComponent: true }));
            setTimeout(() => {
              const { playlistChild } = this.refs;
              playlistChild.refs.carousel.focus();
            }, 300);
          }
        }
      } else if (e.keyCode === UP) {
        if (!this.state.open && this.state.activeComponent) {
          this.setState(() => ({ activeComponent: false }));
        }
      } else if (e.keyCode === BACK || e.keyCode === 27) {
        if (this.state.activeComponent) {
          this.setState(() => ({ activeComponent: false }));
        } else {
          setTimeout(() => {
            this.setState({ open: !this.state.open });
            var no = this.refs.no;
            no.focus();
          }, 700);
        }
      } else if (e.keyCode === ENTER) {
        if (this.state.open) {
          if (this.selectedBtn === 'No') {
            this.setState({ open: false });
            setTimeout(() => {
              var mainDiv = this.refs.mainDiv;
              mainDiv.focus();
            }, 700);
          }
          if (this.selectedBtn === 'Yes') {
            tizen.application.getCurrentApplication().exit();
          }
        }
      }
    };

    this.addOrientationClassToBody();
    // this.onlineStatusInterval = setInterval(() => this.updateOnlineStatus(), 5000);
    if (this.props.hasSubscription) {
      this.interval = setInterval(() => this.FetchFromMobile(), 5000);
      this.mergeMyPlaylist();
    } else {
      this.setArtworkInterval(this.artworkInterval);
    }
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);
  }

  // componentDidUpdate() {
  //   this.addOrientationClassToBody();
  // }

  addOrientationClassToBody() {
    // const currentArtwork = this.state.artworks[this.state.current];

    if (window.innerWidth <= window.innerHeight) {
      // console.log(`Display is vertical orientation: ${window.innerWidth}x${window.innerHeight}`);
      // const v = document.getElementsByTagName('video');
      // const poster = document.getElementById('poster');

      // if (currentArtwork.orientation === 'portrait') {
      //   console.log(`Artwork is legacy and should be rotated.`);
      //   v[0].classList.add('VideoRotated');
      //   poster.classList.add('VideoRotated');
      // } else {
      //   console.log('Artwork is native and should not be rotated.');
      //   v[0].classList.remove('VideoRotated');
      //   poster.classList.remove('VideoRotated');
      // }

      if (document.getElementsByClassName('PlaylistSelector')[0] !== undefined) {
        document.getElementsByClassName('PlaylistSelector')[0].classList.add('PlaylistSelector_Rotated');
      }
    }
  }

  addOrientationClassToPlaylistCarousel() {
    if (window.innerWidth <= window.innerHeight) {
      if (document.getElementsByClassName('PlaylistSelector')[0] !== undefined) {
        document.getElementsByClassName('PlaylistSelector')[0].classList.add('PlaylistSelector_Rotated');
      }
    }
  }

  handleConnectionChange(event) {
    if (event.type == 'offline') {
      fireAnalytics('Network', 'Connection Offline');
      console.log('You lost connection.');
      clearInterval(this.artworkIntervalTime);
      clearInterval(this.interval);
      this.artworkErrorMessage = 'No Internet Connection';
      this.setState({ artworkError: true });
      setTimeout(() => {
        this.setState({ artworkError: false });
      }, 3000);
    }
    if (event.type == 'online') {
      fireAnalytics('Network', 'Connection Online');
      console.log('You are Online.');
      if (this.props.hasSubscription) {
        this.setArtworkInterval(this.artworkInterval);
        this.interval = setInterval(() => this.FetchFromMobile(), 5000);
      } else {
        this.setArtworkInterval(this.artworkInterval);
      }
      this.artworkErrorMessage = 'Connection Online';
      this.setState({ artworkError: true });
      setTimeout(() => {
        this.setState({ artworkError: false });
      }, 3000);
    }
  }

  mergeMyPlaylist() {
    const { length } = this.props.myPlaylist.data;
    if (length > 0) {
      for (let i = 0; i < length; i++) {
        if (this.props?.myPlaylist?.data[i]?.artworks && this.props?.myPlaylist?.data[i]?.artworks.length > 0) {
          this.props.homePlaylist.data.push(this.props.myPlaylist.data[i]);
        }
      }
    }
  }

  setArtworkInterval(interval) {
    if (interval === 0) {
      this.artworkInterval = interval;
      clearInterval(this.artworkIntervalTime);
    } else {
      clearInterval(this.artworkIntervalTime);
      this.artworkInterval = interval;
      this.artworkIntervalTime = setInterval(() => {
        this.k = 1;
        setTimeout(() => {
          this.nextHandle();
        }, 800);
      }, this.artworkInterval);
    }
  }

  async FetchFromMobile() {
    try {
      if (this.props.hasSubscription) {
        const status = await this.props.fetchMobileStatus(this.props.device.data.uid);
        if (status.type === FETCH_MOBILE_STATUS_FAILURE) {
          if (status.errors === 'Device Unregistered') {
            this.props.history.push('/');
            return;
          }
        }

        if (this.props.app.mobileId.localeCompare(status.payload.userId) !== 0) {
          this.props.history.push('/');
          return;
        }

        if (this.state.lastMobileUpdate === null) {
          this.setState({ lastMobileUpdate: status.payload.queueUpdatedAt });
        }

        if (this.artworkInterval !== status.payload.interval) {
          this.setArtworkInterval(status.payload.interval);
        }

        if (this.state.lastMobileUpdate !== status.payload.queueUpdatedAt) {
          const result = await this.props.fetchMobileQueue(this.props.device.data.uid);
          if (result.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          if (result.errors === 'Device Unregistered') {
            this.props.history.push('/');
            return;
          }

          setMuteFlag(status.payload.mute);

          if (result.type === 'FETCH_MOBILE_QUEUE_SUCCESS') {
            this.setState({ lastMobileUpdate: status.payload.queueUpdatedAt });

            if (result.payload.collection.artwork.length <= 0) {
              this.artworkErrorMessage = 'Unable to play the Selected Artwork.';
              this.setState({ artworkError: true });
              setTimeout(() => {
                this.setState({ artworkError: false });
              }, 3000);
              return;
            }
            // const { artworks } = result.payload.queue;
            this.setState({
              artworks: result.payload.collection.artwork,
              current: 0,
            });
            this.setState({ activeComponent: false });
            clearInterval(this.artworkIntervalTime);
            this.artworkInterval = null;
            this.updatePlaylist = false;
            const activePlaylist = this.props.fetchActivePlaylist(result.payload.collection.id);
            if (activePlaylist.errors === 'Error') {
              setTimeout(() => {
                this.props.history.push('/error');
              }, 10);
              return;
            }
            fireAnalytics('Playlist', 'Playlist Received From Mobile', result.payload.collection.id);
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getArtworkFromPlaylist(id) {
    if (this.props.hasSubscription) {
      let activePlaylist = await this.props.fetchActivePlaylist(id);
      if (activePlaylist.errors === 'No Artworks') {
        this.artworkErrorMessage = 'No artworks in Collection';
        this.setState({ activeComponent: false, artworkError: true });
        setTimeout(() => {
          this.setState({ artworkError: false });
        }, 4000);
        await this.props.fetchActivePlaylist(this.prevPlaylistId);
      } else if (activePlaylist.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      } else {
        this.updatePlaylist = true;
      }
      fireAnalytics('Playlist', 'Playlist Changed', id);
    } else {
      this.props.history.push('/Pair');
    }
  }

  async setCurrent(pid) {
    this.props.homePlaylist.data.filter((data, idx) => {
      if (data.playlistId === pid) {
        this.setState({ currentPlaylist: idx });
        return;
      }
    });
  }

  async setExitApp() {
    this.setState({ activeComponent: false });
  }

  prevHandle() {
    clearTimeout(this.state.navTimeout);
    const slides = this.state.artworks.slice(0);
    slides.unshift(slides.pop());

    const navTimeout = setTimeout(() => {
      this.setState((prevState) => ({ ...prevState, navigating: false }));
    }, 4000);

    this.setState((prevState) => ({
      ...prevState,
      navTimeout,
      artworks: slides,
    }));
  }

  nextHandle() {
    clearTimeout(this.state.navTimeout);
    const newArray = this.state.artworks.slice(0);
    newArray.push(newArray.shift());
    const navTimeout = setTimeout(() => {
      this.setState((prevState) => ({ ...prevState, navigating: false }));
    }, 4000);
    this.setState((prevState) => ({
      ...prevState,
      navTimeout,
      artworks: newArray,
    }));
  }

  getCurrentArtworkName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    return artworks[this.state.current].name;
  }

  getCurrentArtworkArtistName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    const { current } = this.state;

    if (artworks[current]?._embedded?.artist?.givenName && artworks[current]?._embedded?.artist?.surname)
      return `${artworks[current]?._embedded?.artist?.givenName} ${artworks[current]?._embedded?.artist?.surname}`;
    else if (artworks[current]?.artist?.displayName) return `${artworks[current]?.artist?.displayName}`;
    else return '';
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedPlaylistId !== this.state.selectedPlaylistId && this.updatePlaylist) {
      this.prevPlaylistId = nextProps.selectedPlaylistId;
      const { artworks } = nextProps;
      this.setState({
        artworks,
        current: 0,
        selectedPlaylistId: nextProps.selectedPlaylistId,
      });
      clearInterval(this.artworkIntervalTime);
      this.setArtworkInterval(this.props.device.data.interval);
      this.setState({ activeComponent: false });
    }
  }

  render() {
    const { current, showNav, artworks } = this.state;
    const slideWidth = 90;
    let left = -current * slideWidth - 90;
    const slides = artworks.map((item, idx) => {
      left += slideWidth;
      if (idx === current) {
        return (
          <div key={idx} className="freemium-full-screen-carousel__slide" style={{ left: `${left}%` }}>
            <Artwork
              isCurrent={idx == current}
              artwork={item}
              hasSubscription={this.props.hasSubscription}
              history={this.props.history}
            />
          </div>
        );
      }
    });

    return (
      <div className="fullscreenFreemiumWrapper" ref="mainDiv">
        {slides}
        {this.state.open ? (
          <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
            <div
              className="model"
              style={{
                width: '40%',
                backgroundColor: 'black',
                color: 'white',
                borderRadius: '15px',
              }}
            >
              <img
                className="Logo2"
                src="assets/img/blackdove-logo-2020.png"
                alt=""
                style={{ width: '50%', paddingTop: '6%' }}
              />
              <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
              <button ref="no" id="No" style={{ background: '#910048' }} className="exitPopup">
                No
              </button>
              <button ref="yes" id="yes" style={{ marginLeft: '2%' }} className="exitPopup">
                Yes
              </button>
            </div>
          </div>
        ) : null}
        {this.state.navigating && (
          <div className="fullscreenNavOverlay">
            {this.props.hasSubscription && (
              <div
                ref="accountButton"
                onClick={() => {
                  this.props.history.push('/Account');
                }}
                tabIndex="1"
                className="btn btn--round btn--dark btn--fill accountBtn"
              >
                {' '}
                Account
              </div>
            )}
            {!this.props.hasSubscription && (
              <div
                ref="upgrade"
                onClick={() => {
                  this.props.history.push('/Pair');
                }}
                tabIndex="1"
                className="btn btn--round btn--dark btn--fill pairBtn"
              >
                Pair QR Code
              </div>
            )}
            <div
              onClick={() => {
                this.prevHandle();
              }}
              className="btn btn--circle navLeft"
            >
              <span tabIndex="2" ref="previous" className="ion-ios-arrow-back btn--arrow" />
            </div>
            <div style={{ textAlign: 'center' }}>
              <h2
                className="h--no-spacing"
                style={{
                  color: 'white',
                  textTransform: 'uppercase',
                  fontSize: '2.5em',
                }}
              >
                {this.getCurrentArtworkName()}
              </h2>
              <h5 className="h--normalize-weight" style={{ color: 'white', fontSize: '1.2em' }}>
                {this.getCurrentArtworkArtistName()}
              </h5>
            </div>
            <div
              onClick={() => {
                this.nextHandle();
                this.k = 1;
              }}
              className="btn btn--circle navRight"
            >
              <span ref="next" tabIndex="3" className="ion-ios-arrow-forward btn--arrow" />
            </div>
          </div>
        )}
        <div className="artworkError" style={!this.state.artworkError ? { display: 'block' } : { display: 'none' }}>
          {this.artworkErrorMessage}
        </div>
        {/* {
          this.state.activeComponent ? ( */}
        <div
          className="PlaylistSelector"
          style={this.state.activeComponent ? { display: 'block' } : { display: 'none' }}
        >
          <SelectedPlaylistCarousel
            ref="playlistChild"
            playlist={this.props.homePlaylist.data}
            currentPlaylist={this.state.currentPlaylist}
            subscription={this.props.hasSubscription}
            history={this.props.history}
            dispatch={this.props.dispatch}
            getArtworkFromPlaylist={(pid) => this.getArtworkFromPlaylist(pid)}
            setCurrent={(pid) => this.setCurrent(pid)}
            onExitApp={() => this.setExitApp()}
          />
        </div>
        {/* )
            : null
        } */}
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  fetchMobileQueue: (deviceId) => dispatch(fetchMobileQueue(deviceId)),
  fetchMobileStatus: (deviceId) => dispatch(fetchMobileStatus(deviceId)),
});

export default connect((state) => {
  const { homePlaylist, userPlaylists, myPlaylist, device, mobileQueue, app } = state;
  return {
    app,
    userPlaylists,
    homePlaylist,
    myPlaylist,
    device,
    mobileQueue,
  };
}, mapDispatchToProps)(FreemiumCarousel);
